module.exports = {
      id: "news-usage",
      viewBox: "0 0 24.597 24.597",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#news",
      toString: function () {
        return this.url;
      }
    }